// extracted by mini-css-extract-plugin
module.exports = {"status":"add-contract-modal_status_1lHG1","controls":"add-contract-modal_controls_2qtL-"};